/**
 * Prototype for a timer object that can keep time and be stopped and started.
 */
const timerPrototype = {
  /**
   * Start the timer
   * @returns {boolean} True if the timer was successfully started, false if it was already started.
   */
  start () {
    if (!this.isStarted()) {
      this._startTime = now()
      return true
    }
    return false
  },

  /**
   * Stops the timer
   * @returns {boolean} True if the timer was successfully stopped, false if it was already stopped.
   */
  stop () {
    if (this.isStarted()) {
      this._startTime = undefined
      return true
    }

    return false
  },

  /**
   * @returns {boolean} True if the timer is started, false otherwise.
   */
  isStarted () {
    return Boolean(this._startTime)
  },

  /**
   * @returns {number} The time in milliseconds since the timer was started, or 0 if it wasn't started.
   */
  timeFromStart () {
    return this.isStarted() ? now() - this._startTime : 0
  }
}

/**
 * @returns A timestamp in milliseconds since the unix-epoch
 */
function now () {
  return new Date().getTime()
}

/**
 * Create a new timer object. Timers are not started when created and need to be started manually.
 *
 * @returns {Object} The timer object that supports the timer interface.
 */
export function createTimer () {
  return Object.create(timerPrototype)
}
